<fa-icon [icon]="iconQuestionCircle" title="Clicca qui per visualizzare l’help" (click)="openHelp(helpdialog)" aria-label="Help online della pagina"></fa-icon>

<ng-template #helpdialog>
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="start start">
    <h2>Help online</h2>
    <span class="flex-spacer"></span>
    <button mat-flat-button mat-dialog-close aria-label="Chiudi help"><fa-icon [icon]="iconTimes" size="lg" aria-label="Chiudi help" alt="Chiudi help"></fa-icon></button>
  </div>

  <mat-dialog-content>
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
  </mat-dialog-content>
</ng-template>
